module.exports = __webpack_public_path__ + "img/auth-bg-3.957b1bf9.svg";